import { p as promiseResolve, b as bootstrapLazy } from './index-40ac3929.js';

/*
 Stencil Client Patch Esm v2.10.0 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["eva-config-picker_6",[[1,"eva-config-picker",{"authState":[32]}],[1,"eva-config-picker-customer",{"viewCustomersSummary":[32],"selectedCustomer":[32],"customerDataState":[32]}],[1,"eva-config-picker-login"],[1,"eva-config-picker-endpoint-status",{"endpoint":[1],"endpointStatus":[32]}],[1,"picker-customer-logo",{"logoPath":[1,"logo-path"],"customerName":[1,"customer-name"],"logoSrc":[32]}],[1,"eva-config-picker-spinner",{"size":[2]}]]]], options);
  });
};

export { defineCustomElements };
